import classNames from "classnames";
import isUndefined from "lodash/isUndefined";
import Chevron from "rivals/components/shared/Icons/Chevron";
import { ROTATE_90 } from "rivals/shared/constants";
import { setData } from "rivals/shared/utils/qa";
import styles from "./index.module.scss";
import { Props } from "./types";

// Text cell with highlight
const HightlightedTextCell = ({
  className,
  highlightColor,
  invertedTextColor = false,
  text,
  isRowOpen
}: Props): JSX.Element => {
  return (
    <div className={styles.highlightCellWrapper}>
      <div className={styles.highlightedCell}>
        <div
          className={classNames(styles.cellHighlight, className, {
            [styles.invertedText]: invertedTextColor
          })}
          style={{ backgroundColor: highlightColor }}
        >
          {text}
        </div>
        {/* The chevron icon is visible when isRowOpen is defined  */}
        {!isUndefined(isRowOpen) && (
          <div
            className={styles.iconContainer}
            {...setData(`expand-toggle-icon-${text}`)}
          >
            <Chevron
              animateRotation={true}
              fill={styles.gray60}
              rotate={isRowOpen ? ROTATE_90 : -ROTATE_90}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default HightlightedTextCell;
